'use client';

import { FoodDetailComponent } from 'components/glucose-db/FoodDetailComponent';
import { FoodOptimizationSection } from 'components/glucose-db/FoodOptimizationSection';
import { HealthSpanSection } from 'components/ring-air-landing';
import { FoodDetailDataType } from 'utils/foodGlucoseDbHelper';
import { CustomImage as Image } from 'components/shared';
import styles from './food-client.module.css';

function BGgradImage({ src }: { src: string }) {
  return (
    <Image
      width={1000}
      height={1000}
      className={styles.bgGradImage}
      alt=""
      src={src}
    />
  );
}

export default function GlucoseResponseDB(props: {
  data: FoodDetailDataType;
  optimizationData: Record<string, unknown>;
  suggestions: {
    name: string;
    food_id: number;
    url_friendly_name: string;
    average_score: number;
  }[];
}) {
  return (
    <main
      style={{
        backgroundColor: '#000000',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <BGgradImage
        src={
          props.data.average_score > 7
            ? 'web_v2/grdb/images/green-blur-ball.png'
            : props.data.average_score > 5
            ? 'web_v2/grdb/images/yellow-blur-ball.png'
            : 'web_v2/grdb/images/red-blur-ball.png'
        }
      />
      <FoodDetailComponent
        data={props.data as FoodDetailDataType}
        suggestions={props.suggestions}
      />
      <FoodOptimizationSection data={props.optimizationData} />
      <HealthSpanSection
        imageMobile="landing/bg/m1_bg_responsive_tinted.png"
        title={
          <>
            Discover <br /> metabolic <br />
            health with M1
          </>
        }
        titleLarge
        description="Ultrahuman M1 helps you measure the impact of food and activity on your body in real time through glucose as a biomarker."
        btnText={<>Explore Ultrahuman M1</>}
        textColor="white"
        ctaLink="/pricing"
        analyticEvent="ogdb-food-detail-m1-cta-clicked"
      />
    </main>
  );
}
